import VideoUpload from "@/views/h5/update/uploaded";
import {
    activityInfo,
    getById,
    insert,
    getUserIdByOpenid
} from '@apis/apis'
import {
    showcontent
} from "../../../utils/method";
// import {showcontent} from "../../utils/method";
export default {
    name: 'sign',
    //import引入的组件需要注入到对象中才能使用
    components: {
        VideoUpload
    },
    data() {
        //这里存放数据
        return {
            id: '',
            openid: '',
            enclosure: '',
            templateId: "",
            username: '',
            password: '',
            userId:'',
            // contlist:'',
            mubanlist: [],
            list1: [{
                    name: "姓名",
                    type: "text",
                    check: "中文",
                    value: "请输入姓名",
                    pattern: "[A-Za-z]{3}",
                    required: true,
                    message: "name",
                    itemValue: '',
                    rules: "[{ required: true, message: '请填写用户名' }]"
                },
                {
                    name: "手机号",
                    type: "text",
                    check: "手机号",
                    value: "请输入手机号",
                    message: "phone",
                    itemValue: '',
                    rules: "[{ required: true, message: '请填写用户名' }]"

                },
                {
                    name: "公司",
                    type: "text",
                    check: "不能为空",
                    value: "请输入公司名称",
                    message: "company",
                    itemValue: '',
                    rules: "[{ required: true, message: '请填写用户名' }]"
                },
                {
                    name: "职务",
                    type: "text",
                    check: "不能为空",
                    value: "请输入职务",
                    message: "work",
                    rules: "[{ required: true, message: '请填写用户名' }]"
                },

            ],
            dialogVisible: false,
            show: false,
            preVideo: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // isMobile,
        showcontent,
        onSubmit(values) {
            // debugger
            let activitiesId = this.id
            let userId = this.userId
            console.log('submit', values);
            // values.push(activitiesId)
            // values.push(userId)
            this.$ajaxPost(insert, {
                values,
                activitiesId,
                userId
            }).then(res => {
                if (res.data.code == '0') {
                    this.$message({
                        title: "成功！",
                        type: "success",
                        message: "报名成功！",
                    })
                    this.$router.go(-1)
                } else {
                    this.$message({
                        title: "错误",
                        type: "error",
                        message: res.data.msg + ",请重新刷新",
                    })
                }
                this.show = false;
                this.enclosure = ''
                this.mubanlist.input.forEach(res => {
                    res.itemValue = ''
                })
                console.log(res);
            })
        },
        getlist() {
            this.list = this.$route.query
            this.id = this.list.id
            this.openid = this.$route.query.openid
            this.templateId = this.$route.query.templateId
            console.log((this.$route.query));
            this.getByIdlist()
            this.getUser(this.openid)
        },
        //通过id查询模板
        getByIdlist() {
            const id = this.templateId
            this.$ajaxGet(`${getById}?id=${id}`).then(res => {
                res.data.data.content = JSON.parse(showcontent(res.data.data.content))
                this.mubanlist = res.data.data.content
                console.log(this.mubanlist);
            })


        },
        //通过openid查询userid
        getUser(id) {
            this.$ajaxGet(`${getUserIdByOpenid}?openid=${id}`).then(res => {
                this.userId = res.data.data
            })
        },
        removeVideo() {
            this.enclosure = "";
        },
        showPopup() {
            this.show = true;
        },
        closebj() {
            this.show = false;
            this.enclosure = ''
            this.mubanlist.input.forEach(res => {
                res.itemValue = ''
            })
            // this.contlist = ''
        },
        videoUploaded(url, name) {
            console.log(name);
            this.enclosure = url;

        },
        sda() {
            // 把所有输入的值组成一个数组
            const newArr = this.list1.map(item => item.itemValue)
            // 吧后端需要绑定的字段名组成一个数组
            const arr = this.list1.map(item => item.message)
            const obj = {}
            // 一一对应输出
            arr.forEach((item, index) => {
                newArr.forEach((newItem, newIndex) => {
                    if (index == newIndex) {
                        obj[item] = newItem
                    }
                })
            })
            console.log(obj);
            // let ssd = {}
            // const newArr = this.list1.map(item => item.message)
            // const arr = ['name', 'pad']
            // arr.forEach(res =>{
            //     newArr.forEach(newItem =>{
            //         ssd[res] = newItem
            //     })
            // })
            // console.log(ssd);
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getlist()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}